import { ReactJSXElement } from '@emotion/react/types/jsx-namespace';
import React, { Fragment } from 'react';
import { Icon } from '../Icon';
import BreadcrumbItem from './BreadcrumbItem';
import styles from './Breadcrumb.module.scss';

export type BreadcrumbProps = {
  children: ReactJSXElement | ReactJSXElement[];
};

export const Breadcrumb = ({ children }: BreadcrumbProps) => {
  const crumbs = React.Children.map(children, (child, currentIndex) => (
    <Fragment key={currentIndex}>
      {currentIndex !== 0 && <Icon name="Slash" right={14} size={20} />}
      {child}
    </Fragment>
  ));

  return (
    <div className={styles.BreadcrumbContainer} data-testid="Breadcrumb">
      {crumbs}
    </div>
  );
};

Breadcrumb.Item = BreadcrumbItem;
